export class DefaultFormulaireCritere {

    public organismeCode: any;
    public marcheCode: any;
    public montantCode: any;
    public avisCode: any;

    public organismeLibelle: any;
    public marcheLibelle: any;
    public montantLibelle: any;
    public avisLibelle: any;

}